import Cookies from 'js-cookie';

export const ACCESS_TOKEN_KEY = 'accessToken';
/** Legacy single cookie (pre–per-client); migrated on read when it matches the requested client */
export const LAST_ROOM_PATH = 'lastRoomPath';

export const lastRoomPathKey = (clientId: string) => `${LAST_ROOM_PATH}_${clientId}`;
export const REFRESH_TOKEN_KEY = 'refreshToken';
const config = {
  secure: process.env.NODE_ENV !== 'development'
};

/**
 * @return TokenStorage service
 */
export class StorageServices {
  /**
   * @returns function handle set token in cookies
   */
  setAccessToken(accessToken: string, key = ACCESS_TOKEN_KEY) {
    Cookies.set(key, accessToken, config);
  }

  /**
   * @returns function handle get token in cookies
   */
  getAccessToken(key = ACCESS_TOKEN_KEY): string | undefined {
    return Cookies.get(key);
  }

  /**
   * @returns function handle remove token in cookies
   */
  removeAccessToken(key = ACCESS_TOKEN_KEY) {
    return Cookies.remove(key);
  }
  /**
   * @returns function handle set token in cookies
   */
  setRefreshToken(accessToken: string) {
    Cookies.set(REFRESH_TOKEN_KEY, accessToken, config);
  }

  /**
   * @returns function handle get token in cookies
   */
  getRefreshToken(): string | undefined {
    return Cookies.get(REFRESH_TOKEN_KEY);
  }

  /**
   * @returns function handle remove token in cookies
   */
  removeRefreshToken() {
    return Cookies.remove(REFRESH_TOKEN_KEY);
  }
  /**
   * @returns function handle set token in cookies
   */
  setLastRoomPath(path: string, clientId: string) {
    if (!clientId) return;
    Cookies.set(lastRoomPathKey(clientId), JSON.stringify(path), config);
    Cookies.remove(LAST_ROOM_PATH);
  }

  /**
   * @returns function handle get token in cookies
   */
  getLastRoomPath(clientId?: string): string {
    if (!clientId) return '';
    const key = lastRoomPathKey(clientId);
    const current = Cookies.get(key);
    if (current) {
      try {
        return JSON.parse(current as string) as string;
      } catch {
        return '';
      }
    }
    const legacy = Cookies.get(LAST_ROOM_PATH);
    if (legacy) {
      try {
        const path = JSON.parse(legacy as string) as string;
        if (
          typeof path === 'string' &&
          path.includes('/clients/') &&
          new RegExp(`/clients/[^/]+/${clientId}/`).test(path)
        ) {
          Cookies.set(key, JSON.stringify(path), config);
          Cookies.remove(LAST_ROOM_PATH);
          return path;
        }
      } catch {
        return '';
      }
    }
    return '';
  }

  /**
   * @returns function handle remove token in cookies
   */
  removeLastRoomPath(clientId?: string) {
    if (clientId) Cookies.remove(lastRoomPathKey(clientId));
    else Cookies.remove(LAST_ROOM_PATH);
  }
}
